
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { QuestionModel } from './Entities.GormCrm.Question';
import { QuestionnaireModel } from './Entities.GormCrm.Questionnaire';
import { Model, ModelProperty } from 'models/Model';


export class QuestionnaireQuestionModel extends Model<QuestionnaireQuestionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'questionnaireId', type: 'string' },
		{ name: 'questionId', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'required', type: 'boolean' },
		{ name: 'sortOrder', type: 'number' },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'question', type: 'QuestionModel', isHidden: true, isObject: true, new: () => { return new QuestionModel }, properties: () => { return QuestionModel.classProperties } },
		{ name: 'questionnaire', type: 'QuestionnaireModel', isHidden: true, isObject: true, new: () => { return new QuestionnaireModel }, properties: () => { return QuestionnaireModel.classProperties } }
	];
	[key: string]: any;
	
	public questionnaireId?: string;
	public questionId?: string;
	public created?: Date;
	public required: boolean;
	public sortOrder?: number;
	public deleted?: Date;
	public question?: QuestionModel;
	public questionnaire?: QuestionnaireModel;
    
	constructor(){
		super();
		this.questionnaireId = undefined;
		this.questionId = undefined;
		this.created = undefined;
		this.required = false;
		this.sortOrder = undefined;
		this.deleted = undefined;
		this.question = undefined;
		this.questionnaire = undefined;
		
	}
	getProperties(){
		return QuestionnaireQuestionModel.classProperties;
	}
}

